import { css } from '@emotion/css'

export const PiModalClass = css`
  .css-4kplgf {
    border-radius: 8px !important;
    /*box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.12) !important;*/
  }
`
